import {
  ButtonAppearance,
  ButtonCustomLink,
  DisableFocusWrapper,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  buttonPaddingGenerator,
} from '@vw-marketing/us-components';
import React from 'react';
import { ParagraphSection } from '../paragraph-section';
import { ButtonContainer } from './styled';

export const FindADealerCtaSection = (prop) => (
  <>
    {prop.showFind && (
      <ButtonContainer>
        <DisableFocusWrapper>
          <ButtonCustomLink
            appearance={ButtonAppearance.Primary}
            href={'/app/dccsearch/vw-us/en/'}
            padding={buttonPaddingGenerator(0)}
          >
            <TextCustom
              appearance={TextAppearance.label100}
              style={{
                fontSize: TextSize.TextSize14,
                lineHeight: TextLineHeight.TextLineHeight16,
                color: TextColor.inherit,
              }}
            >
              Find a Dealer
            </TextCustom>
          </ButtonCustomLink>
        </DisableFocusWrapper>
      </ButtonContainer>
    )}

    <ParagraphSection
      marginBottom="0"
      textColor="#515a5e"
      richtext={
        'Visit <b>[VWCourtSettlement.com](http://vwcourtsettlement.com)</b> to determine what other benefits you may be eligible to receive.'
      }
    />
  </>
);
